export const DEFAULT_FONT_SIZE = 18;
export const COLOR_ACCENT = '#7E51DC';

export const BREAKPOINT = {
    MIN: 540,
    MOBILE: 767,
    TABLET: 1023,
    DESKTOP: 1280
}
